import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,
  
  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    targets:[],
    target:[],
  
    
  },
  mutations: {


    LoadProductos(state,buscar) {
      //let aux = [];
      state.target = state.targets;

      let aux = state.targets.filter((x) => x["nombretarget"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.target = state.targets;
      } else {
        state.target = aux;
      
      }
    },

    async  cargardatostargets(state){
      
      state.targets = []
      var token = store.state.numero;
      await axios
      .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/targets", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        state.targets = response.data.data;
      
      });
      state.target = state.targets
    },
    
    cambio(state,descripcion){
     state.descripcionmodal =descripcion
  
    },
    agregartable(state)  {
      
      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombretarget: state.descripcionmodal
      };
      this.banderamodal = store.state.banderamodal
      
     
      
      var datosfalso = state.idmodal;
     
      if (this.banderamodal === true) {
        
        
        axios
        
        .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/targets", datos, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          this.token = tokenn;
      
          
          
        })
        
        .catch((e) => {
          console.log(e);
        });
      } else {
        
        axios
        
        .post(
          "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/targets/UpdateReg/" +
          datosfalso,
          datos,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
        
          })
          
          .catch((e) => {
            console.log(e);
          });
        }
        
      },
      
      
      datosmodal(state, api) {
   
        state.idmodal = api.idtarget,
        state.descripcionmodal = api.nombretarget
        
      },
      
      
      
      eliminar(state, api) {
        var token = store.state.numero
        let eliminar = api;
    
        axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/targets/DeleteReg/" + eliminar,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        
        
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;
        
          //this.bandera = true;
        })
        
        .catch((e) => {
          console.log(e);
        });
        
        
        
      },
      
      
      
    },
    actions: {
      
    },
    getters: {
      
      
    },
    
    
    



}